import { rest } from 'msw';

export async function sleep(timeout: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
}
/**
 *
 * @param path
 * @returns path 맨앞에 *를 붙이고 {params} 형식을 :params 로 변경해주는 함수
 */
export function convertPath(path) {
  return '*' + path.replace(/{(.*?)}/g, ':$1');
}

const httpMethods = {
  GET: rest.get,
  POST: rest.post,
  PUT: rest.put,
  DELETE: rest.delete,
  PATCH: rest.patch,
};

export function createHandler({ method, path }, handlerFunction) {
  const mswMethod = httpMethods[method.toUpperCase()];
  if (!mswMethod) {
    throw new Error(`Unsupported HTTP method: ${method}`);
  }
  return mswMethod(convertPath(path), handlerFunction);
}
